import { render, staticRenderFns } from "./ScheduleDoctors.vue?vue&type=template&id=f35387aa&scoped=true&"
import script from "./ScheduleDoctors.vue?vue&type=script&lang=js&"
export * from "./ScheduleDoctors.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleDoctors.vue?vue&type=style&index=0&id=f35387aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35387aa",
  null
  
)

export default component.exports